var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("筛选查询")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form",
                              {
                                staticClass: "demo-form-inline",
                                attrs: { inline: true, model: _vm.form }
                              },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "输入搜索：" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "用户id" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.search_user_id,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.form,
                                            "search_user_id",
                                            $$v
                                          )
                                        },
                                        expression: "form.search_user_id"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "仓位" },
                                      nativeOn: {
                                        keyup: function($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.search.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      },
                                      model: {
                                        value: _vm.form.space,
                                        callback: function($$v) {
                                          _vm.$set(_vm.form, "space", $$v)
                                        },
                                        expression: "form.space"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "是否开启仓库改标"
                                        },
                                        model: {
                                          value: _vm.form.is_label,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "is_label", $$v)
                                          },
                                          expression: "form.is_label"
                                        }
                                      },
                                      _vm._l(_vm.is_label, function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.name,
                                            value: item.key
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.search }
                                      },
                                      [_vm._v("查询")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.reset }
                                      },
                                      [_vm._v("重置")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      background: "#f3f3f3",
                      height: "50px",
                      "line-height": "30px",
                      padding: "0 25px",
                      display: "flex",
                      "align-items": "center"
                    }
                  },
                  [
                    _c("div", [_vm._v("数据列表：")]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "auto" },
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("导出")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      { staticStyle: { "margin-bottom": "0" } },
                      [
                        _c(
                          "el-table",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { height: "600", data: _vm.resData.data }
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "user_id", label: "用户id" }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "is_label",
                                label: "是否开启仓库改标",
                                width: "120",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "改标示例图片",
                                align: "center",
                                width: "100"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.imgs.length > 0
                                          ? _c("el-image", {
                                              staticStyle: {
                                                width: "100px",
                                                height: "100px"
                                              },
                                              attrs: {
                                                src: scope.row.imgs[0],
                                                "preview-src-list":
                                                  scope.row.imgs
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                357972411
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "改标备注",
                                align: "center",
                                width: "200"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        scope.row.label_tag
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                服务项：" +
                                                  _vm._s(scope.row.label_tag) +
                                                  "\n              "
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.label_note
                                          ? _c("div", [
                                              _vm._v(
                                                "\n                备注：" +
                                                  _vm._s(scope.row.label_note) +
                                                  "\n              "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1940319242
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "space_txt",
                                label: "改标仓位",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "admin_name",
                                label: "更新人",
                                width: "120",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "update_time",
                                label: "更新时间",
                                "show-overflow-tooltip": "",
                                align: "center"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "操作",
                                "show-overflow-tooltip": "",
                                align: "center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.clickDialog(
                                                  scope.row
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("操作")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.showLog(scope.row)
                                              }
                                            }
                                          },
                                          [_vm._v("\n                日志")]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                229245248
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.resData
                  ? _c(
                      "div",
                      {
                        staticStyle: { "text-align": "right", padding: "25px" }
                      },
                      [
                        _c("el-pagination", {
                          attrs: {
                            "current-page": _vm.resData.current_page,
                            background: "",
                            layout: "total, prev, pager, next, jumper ,sizes",
                            total: _vm.resData.total,
                            "page-size": _vm.resData.per_page,
                            "page-sizes": [10, 20, 50, 100]
                          },
                          on: {
                            "update:currentPage": function($event) {
                              return _vm.$set(
                                _vm.resData,
                                "current_page",
                                $event
                              )
                            },
                            "update:current-page": function($event) {
                              return _vm.$set(
                                _vm.resData,
                                "current_page",
                                $event
                              )
                            },
                            "current-change": _vm.handleCurrentChange,
                            "size-change": _vm.handleSizeChange
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑",
            visible: _vm.dialogFormVisible,
            "before-close": _vm.closeDialog,
            width: "40%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.editForm } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "改标用户" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.editForm.user_id,
                      callback: function($$v) {
                        _vm.$set(_vm.editForm, "user_id", $$v)
                      },
                      expression: "editForm.user_id"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "改标仓位" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.editForm.space_txt,
                      callback: function($$v) {
                        _vm.$set(_vm.editForm, "space_txt", $$v)
                      },
                      expression: "editForm.space_txt"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "改标备注" } },
                [
                  _vm._l(_vm.resData.label_tags, function(item) {
                    return _c(
                      "el-tag",
                      {
                        key: item,
                        staticClass: "tag",
                        attrs: { type: _vm.tagType(item) },
                        on: {
                          click: function($event) {
                            return _vm.setTag(item)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.label) + "\n        "
                        )
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    ref: "label_note_textarea",
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.editForm.label_note,
                      callback: function($$v) {
                        _vm.$set(_vm.editForm, "label_note", $$v)
                      },
                      expression: "editForm.label_note"
                    }
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "改标示例图片" } }, [
                _c(
                  "div",
                  { staticClass: "upload" },
                  [
                    _c(
                      "el-upload",
                      {
                        ref: "example_upload",
                        staticClass: "upload-demo",
                        attrs: {
                          action: _vm.action,
                          "on-remove": _vm.handleImgRemove,
                          "on-success": _vm.handleImgSuccess,
                          "on-exceed": _vm.handleImgExceed,
                          "list-type": "picture-card",
                          "file-list": _vm.fileList,
                          limit: 5,
                          "with-credentials": ""
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "small", type: "primary" } },
                          [_vm._v("点击上传")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "el-upload__tip",
                            attrs: { slot: "tip" },
                            slot: "tip"
                          },
                          [
                            _vm._v(
                              "\n              只能上传jpg/png文件，且不超过500kb\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c("el-button", { on: { click: _vm.closeDialog } }, [
                _vm._v("取 消")
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "操作日志", visible: _vm.dialogTableVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.gridData } },
            [
              _c("el-table-column", {
                attrs: {
                  property: "create_time",
                  label: "操作时间",
                  width: "250"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  property: "action_admin",
                  label: "操作人",
                  width: "200"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { property: "action_desc", label: "操作内容" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85c6c81c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85c6c81c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/LabelUserSpace.vue
// module id = null
// module chunks = 